import { ITimelineItem } from '@clients/timelineClient';
import TransactionOneLiner from '@components/accountTimeline/accountTimelineBlock/TimelineBlockItems/TransactionOneliner';
import TimelineItemIconFactory from '@components/accountTimeline/accountTimelineBlock/TimelineItemIconFactory';
import TimelineItemTemplate from '@components/accountTimeline/accountTimelineBlock/TimelineItemTemplate';
import accountTimelineType from '@messages/accountTimelineType';
import getEnumTranslation from '@utils/getEnumTranslation';

export type TimelineItemCardProps = {
    timelineItem: ITimelineItem;
    highlightOnHover?: boolean;
    panelMode?: boolean;
    showTooltip?: boolean;
};

const TimelineItemCard = ({
    timelineItem,
    highlightOnHover = false,
    panelMode = false,
    showTooltip = false,
}: TimelineItemCardProps) => {
    const title = getEnumTranslation('CARD', {
        messages: accountTimelineType,
    });

    const url = `/${timelineItem?.account_id}/timeline/${btoa(
        timelineItem?.timestamp,
    )}`;

    const urlForNextCursor = timelineItem?.next_cursor
        ? `/nextCursor/${timelineItem?.next_cursor}`
        : ``;

    return (
        <TimelineItemTemplate
            key={timelineItem.timestamp}
            testId="timelineitem-card"
            primaryTitle={title}
            avatar={
                <TimelineItemIconFactory
                    type={timelineItem.type}
                    category={timelineItem.category}
                />
            }
            primarySubtitle={
                <TransactionOneLiner
                    key={timelineItem.timestamp}
                    timestamp={timelineItem.timestamp}
                    category={timelineItem.category}
                    type={timelineItem.type}
                    showTooltip={showTooltip}
                />
            }
            secondaryTitle=""
            secondarySubtitle=""
            urlToNavigateTo={url + urlForNextCursor}
            highlightOnHover={highlightOnHover}
            panelMode={panelMode}
        />
    );
};

export default TimelineItemCard;
